import { getVarsoUrl } from "../../../../common/helpers/helpers";

export const alphaMissenseUrl = getVarsoUrl(
  "https://www.science.org/doi/10.1126/science.adg7492"
);
export const eveUrl = getVarsoUrl("https://evemodel.org/");
export const dbnsfpUrl = getVarsoUrl(
  "https://sites.google.com/site/jpopgen/dbNSFP"
);
export const dannUrl = getVarsoUrl("https://pubmed.ncbi.nlm.nih.gov/25338716/");
export const MutationTasterUrl = getVarsoUrl("http://www.mutationtaster.org/");
export const MutationAssessorUrl = getVarsoUrl(
  "http://mutationassessor.org/r3/"
);
export const fathmmUrl = getVarsoUrl("http://fathmm.biocompute.org.uk");
export const fathmmMklUrl = getVarsoUrl(
  "http://fathmm.biocompute.org.uk/fathmmMKL.htm"
);
export const fathmmXfUrl = getVarsoUrl(
  "http://fathmm.biocompute.org.uk/fathmm-xf/"
);
export const LRTUrl = getVarsoUrl(
  "http://www.genetics.wustl.edu/jflab/lrt_query.html"
);
export const deogen2Url = getVarsoUrl("http://deogen2.mutaframe.com/");
export const aloftUrl = getVarsoUrl("http://aloft.gersteinlab.org/");
export const eigenUrl = getVarsoUrl(
  "http://www.columbia.edu/~ii2135/eigen.html"
);
export const siftUrl = getVarsoUrl("http://provean.jcvi.org/index.php");
export const sift4gUrl = getVarsoUrl(
  "http://sift.bii.a-star.edu.sg/sift4g/public//Homo_sapiens/"
);
export const proveanUrl = getVarsoUrl("http://provean.jcvi.org/index.php");
export const mvpUrl = getVarsoUrl("https://github.com/ShenLab/missense");
export const revelUrl = getVarsoUrl(
  "https://sites.google.com/site/revelgenomics/"
);
export const mutpredUrl = getVarsoUrl("http://mutpred.mutdb.org/");
export const primateaiUrl = getVarsoUrl(
  "https://github.com/Illumina/PrimateAI"
);
export const bayesdelUrl = getVarsoUrl(
  "http://fengbj-laboratory.org/BayesDel/BayesDel.html"
);
export const lists2Url = getVarsoUrl("https://precomputed.list-s2.msl.ubc.ca/");
export const caddUrl = getVarsoUrl("https://cadd.gs.washington.edu/");
export const caddSplicingURL = getVarsoUrl(
  "https://genomemedicine.biomedcentral.com/articles/10.1186/s13073-021-00835-9"
);
export const mcapUrl = getVarsoUrl("http://bejerano.stanford.edu/MCAP/");
export const metaRnnUrl = getVarsoUrl("http://www.liulab.science/metarnn.html");
export const dbscSNVUrl = "https://sites.google.com/site/jpopgen/dbNSFP";
export const blosumUrl = "https://en.wikipedia.org/wiki/BLOSUM";
